module.exports = __webpack_public_path__ + "img/análise inicial 3.5723b606.webp";